<template>
  <el-collapse>
    <el-collapse-item title="Aspectos de la ley Laboral " name="1">
      <el-card style="padding: 10px">
        <p><strong>Aspectos de la ley Laboral </strong></p>
        <p>
          <strong
            ><em
              >Ley n&uacute;m. 1692, de 29 de mayo de 1992, por la que se
              promulga el C&oacute;digo de Trabajo.</em
            ></strong
          >
        </p>
        <p>
          <strong
            ><em><u>De las vacaciones </u></em></strong
          >
        </p>
        <p><strong>&nbsp;</strong></p>
        <p>
          <strong>Art. 177.-</strong> (Modificado por la Ley N&ordm; 97-97, de
          fecha 30 del mes de mayo del a&ntilde;o 1997, G.O. 9955 del 31 de mayo
          de 1997). Los empleadores tienen la obligaci&oacute;n de conceder a
          todo trabajador un per&iacute;odo de vacaciones de catorce (14)
          d&iacute;as laborables con disfrute de salario, conforme a la escala
          siguiente:
        </p>
        <ol>
          <li>
            Despu&eacute;s de un trabajo continuo no menor de un a&ntilde;o ni
            mayor de cinco, catorce d&iacute;as de salario ordinario;
          </li>
          <li>
            Despu&eacute;s de un trabajo continuo no menor de cinco a&ntilde;os,
            dieciocho (18) d&iacute;as de salario ordinario.
          </li>
        </ol>
        <p>
          Las vacaciones pueden ser fraccionadas por acuerdo entre el trabajador
          y el empleador, pero en todo caso, el trabajador debe disfrutar de un
          per&iacute;odo de vacaciones no inferior a una semana.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong
            ><em
              ><u
                >Nota: Esta divisi&oacute;n de 14 y 18 es para pago del salario
                ordinario (pago de vacaciones). Para el disfrute son 14
                d&iacute;as siempre ver Art. 178.
              </u></em
            ></strong
          >
        </p>
        <p>&nbsp;</p>
        <p>
          Se proh&iacute;be el fraccionamiento si el trabajador es menor de
          edad.
        </p>
        <p>
          <strong>Art. 178</strong>.- El trabajador adquiere el derecho a
          vacaciones cada vez que cumpla un a&ntilde;o de servicio
          ininterrumpido en una empresa.
        </p>
        <p><strong>&nbsp;</strong></p>
        <p><strong>&nbsp;</strong></p>
        <p><strong>&nbsp;</strong></p>
        <p><strong>&nbsp;</strong></p>
        <p>
          <strong>Art. 179</strong>.- Los trabajadores sujetos a contratos por
          tiempo indefinido que, sin culpa alguna de su parte, no puedan tener
          oportunidad de prestar servicios ininterrumpidos durante un
          a&ntilde;o, a causa de la &iacute;ndole de sus labores o por
          cualquiera otra circunstancia, tienen derecho a un per&iacute;odo de
          vacaciones proporcional al tiempo trabajado, si &eacute;ste es mayor
          de cinco meses.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 180.-</strong> Para la aplicaci&oacute;n del
          art&iacute;culo 179 rige la siguiente escala: Trabajadores con
          m&aacute;s de cinco meses de servicios, seis d&iacute;as; Trabajadores
          con m&aacute;s de seis meses de servicios, siete d&iacute;as;
          Trabajadores con m&aacute;s de siete meses de servicio, ocho
          d&iacute;as; Trabajadores con m&aacute;s de ocho meses de servicio,
          nueve d&iacute;as; Trabajadores con m&aacute;s de nueve meses de
          servicio, diez d&iacute;as; C&oacute;digo de Trabajo de la
          Rep&uacute;blica Dominicana 71 Trabajadores con m&aacute;s de diez
          meses de servicios, once d&iacute;as; Trabajadores con m&aacute;s de
          once meses de servicios, doce d&iacute;as.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong
            ><em
              ><u
                >Nota: Art. 179 y 180 aplican para pago en caso de concluir el
                contrato, para disfrute es despu&eacute;s del a&ntilde;o. Ver
                art. 178.</u
              ></em
            ></strong
          >
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 181</strong>.- El salario correspondiente al
          per&iacute;odo de vacaciones debe ser pagado al trabajador el
          d&iacute;a anterior al del inicio de &eacute;stas, junto con los
          salarios que a esta fecha hubiera ganado. El salario correspondiente
          al per&iacute;odo de vacaciones comprende la remuneraci&oacute;n
          habitual, seg&uacute;n lo dispuesto en el art&iacute;culo 177, y el
          equivalente de su remuneraci&oacute;n en especie, si la hubiere.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 182.-</strong> Durante el per&iacute;odo de vacaciones el
          trabajador no puede prestar servicios, remunerados o no, a
          ning&uacute;n empleador. El derecho a vacaciones no puede, en
          ning&uacute;n caso, ser objeto de compensaci&oacute;n ni de
          sustituci&oacute;n alguna. Sin embargo, si el trabajador dejare de ser
          empleado de un establecimiento o empresa sin haber disfrutado del
          per&iacute;odo de vacaciones a que tuviere derecho, recibir&aacute; de
          su empleador una compensaci&oacute;n pecuniaria equivalente a los
          salarios correspondientes a dicho per&iacute;odo vacacional, conforme
          a lo dispuesto en el art&iacute;culo 177.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 183</strong>.- En caso de que el salario del trabajador
          sea pagado por labor rendida, el c&aacute;lculo de la
          compensaci&oacute;n establecida en el art&iacute;culo anterior se
          har&aacute; con el promedio diario de los salarios devengados durante
          los &uacute;ltimos doce meses o el per&iacute;odo menor que haya
          trabajado el candidato a vacaciones.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 184</strong> (Modificado por la Ley N&ordm; 25-98, de
          fecha 15 del mes de enero del a&ntilde;o 1998, G.O. 9972 del 15 de
          enero de 1998). El derecho de compensaci&oacute;n por vacaciones no
          disfrutadas debe ser pagado, sea cual fuere la causa de
          terminaci&oacute;n del contrato.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 185</strong>.- Las vacaciones no pueden ser suspendidas o
          disminuidas a consecuencia de las faltas de asistencia del trabajador,
          cuando &eacute;stas hayan ocurrido por enfermedad u otra causa
          justificada. Tampoco podr&aacute;n ser suspendidas o disminuidas en
          los casos de falta de asistencia injustificada siempre que el
          empleador no haya pagado al trabajador esos d&iacute;as no trabajados.
        </p>
        <p>
          <strong>Art. 186</strong>.- Los empleadores deben fijar y distribuir,
          durante los primeros quince d&iacute;as del mes de enero, los
          per&iacute;odos de vacaciones de sus trabajadores. LA
          Secretar&iacute;a de Estado de Trabajo Deben, adem&aacute;s, en el
          mismo plazo, enviar al Departamento de Trabajo copia de la
          distribuci&oacute;n y fijar otra en lugar visible de sus talleres o
          establecimientos.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 187</strong>.- Los trabajadores cuyo derecho a vacaciones
          se adquiera con posterioridad al quince de enero, deben ser incluidos
          por el empleador en n&oacute;minas adicionales dentro de los treinta
          d&iacute;as de la fecha en que se haya adquirido dicho derecho.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 188.-</strong> El empleador puede variar, en caso de
          necesidad, la distribuci&oacute;n del per&iacute;odo de vacaciones,
          pero por ninguna circunstancia, los trabajadores dejar&aacute;n de
          disfrutar &iacute;ntegramente de las vacaciones
          <strong
            >dentro de los seis meses de la fecha de adquisici&oacute;n del
            derecho</strong
          >.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 189</strong>.- Todo trabajador, al comenzar el disfrute
          de sus vacaciones, deber&aacute; firmar la constancia correspondiente
          de un libro-registro que llevar&aacute; el empleador para este fin. En
          ese libro registro deber&aacute; indicarse:
        </p>
        <ol>
          <li>
            a) la fecha en que entren a prestar servicios sus trabajadores y la
            duraci&oacute;n de las vacaciones pagadas a que cada uno tenga
            derecho; b) la fecha en que cada trabajador tome sus vacaciones
            anuales pagadas;
          </li>
          <li>
            c) la remuneraci&oacute;n recibida por cada trabajador durante el
            per&iacute;odo de sus vacaciones anuales pagadas. En caso de no
            saber firmar, el trabajador estampar&aacute; sus se&ntilde;as
            digitales.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 190</strong>.- Durante el per&iacute;odo de vacaciones el
          empleador no puede iniciar contra el trabajador que las disfruta
          ninguna de las acciones previstas en este C&oacute;digo.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Art. 191.</strong>- El empleador est&aacute; obligado a
          reemplazar temporalmente por otros a los trabajadores en vacaciones,
          cuando como consecuencia de ellas las labores encomendadas al personal
          resulten extraordinariamente recargadas. Es potestativo del empleador
          aumentar la duraci&oacute;n del per&iacute;odo de vacaciones.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>El Art. 238 del CT dispone que</strong>
          &ldquo;cuando una trabajadora solicite la concesi&oacute;n de sus
          vacaciones, inmediatamente despu&eacute;s del descanso postnatal el
          empleador est&aacute; obligado a acceder a su solicitud&rdquo;.
        </p>
      </el-card>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
export default {
  name: "InfotVacation"
};
</script>
